import React, { Ref, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery } from '../../convex/_generated/react'

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Select
} from '@chakra-ui/react'
import { CurrencyList, Resource, ResourceSchema } from '../../types'
import { Id } from '../../convex/_generated/dataModel'

interface IProps {
  _id?: Id
  formRef ?: Ref<HTMLFormElement>
  onSuccess?: () => void
}

const ResourceForm: React.FC<IProps> = ({ _id, onSuccess, formRef }) => {
  const currentClient = useQuery('clientById', _id || null)

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset
  } = useForm<Resource>()

  useEffect(() => {
    if (currentClient) {
      reset(currentClient)
    }
  }, [currentClient])

  const createResource = useMutation('createResource')
  const updateResource = useMutation('updateResource')

  const onSubmit = async (data: Omit<ResourceSchema, '_id'>) => {
    if (_id) {
      updateResource({
        ...data,
        _id
      })
      onSuccess && onSuccess()
      return
    }

    await createResource(data)
    onSuccess && onSuccess()
  }

  return (
    <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>

      <FormControl>
        <FormLabel>Name</FormLabel>
        <Input {...register('name')} placeholder='Name of company' />
        <FormErrorMessage>
          {errors.name && errors.name.message}
        </FormErrorMessage>
      </FormControl>

      <FormControl mt={4}>
        <FormLabel>Designation</FormLabel>
        <Input {...register('designation')} placeholder='Designation' />
        <FormErrorMessage>
          {errors.designation && errors.designation.message}
        </FormErrorMessage>
      </FormControl>

      <FormControl mt={4}>
        <FormLabel>Email address</FormLabel>
        <Input {...register('email')} placeholder='Email address' />
        <FormErrorMessage>
          {errors.email && errors.email.message}
        </FormErrorMessage>
      </FormControl>

      <FormControl mt={4}>
        <FormLabel>Location</FormLabel>
        <Input {...register('location')} placeholder='Location' />
        <FormErrorMessage>
          {errors.location && errors.location.message}
        </FormErrorMessage>
      </FormControl>

      <Input type="hidden" {...register('rateType')} />

      <FormControl mt={4}>
        <FormLabel>Currency</FormLabel>
        <Select {...register('currency')} placeholder='Currency'>
          { CurrencyList.map(value => <option key={value} value={value}>{ value }</option>) }
        </Select>
        <FormErrorMessage>
          {errors.currency && errors.currency.message}
        </FormErrorMessage>
      </FormControl>

      <FormControl mt={4}>
        <FormLabel>Hourly rate</FormLabel>
        <Input {...register('rate')} placeholder='Hourly rate' />
        <FormErrorMessage>
          {errors.rate && errors.rate.message}
        </FormErrorMessage>
      </FormControl>
    </form>
  )
}

export default ResourceForm
